import React from 'react';
import lili from '../../images/lili.png'
import Button from '../../share/button/Button';
import { setModalStage } from '../../store/modalSlice';
import { useDispatch } from 'react-redux';

const CreateNewEth = () => {
    const dispatch = useDispatch();

    const continueToConnect = () => {
        dispatch(setModalStage('CONNECT_NEW_ETH'));
    };

    return (
        <div className="flex flex-col items-center gap-4">
            <img src={lili} className="w-[150px] sm:w-[190px] h-auto mb-2" alt="Lili" />
            <div className="flex flex-col items-center gap-2 text-center">
                <h2 className="text-white uppercase text-[clamp(1.4rem,4.5vw,2.5rem)] leading-tight">Mint your Lilverse NFT</h2>
                <p className="font-dang text-lg sm:text-xl md:text-[1.6rem] text-white -tracking-[1px] max-w-[500px]">
                    Connect your Ethereum wallet to mint your Lilverse character.
                </p>
            </div>
            <Button onClick={continueToConnect} size="cta">CONTINUE</Button>
        </div>
    );
};

export default CreateNewEth;
